import { createContext, useContext } from 'react'

export const ManageCategoryContext = createContext(null)

export const useManageCategoryContext = () => {
  return useContext(ManageCategoryContext)
}
